import Vue                from "vue";
import Vuex               from "vuex";
import { performRequest } from "../script/ws/wsclient";
import _                  from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
	state:     {
		cycle:               0,
		parameters:          "",
		selectedMenu:        "",
		reqUserRole:         "",
		optionForParameters: {},
		arrayTotal:          [[]],
		arrayFilter:         [[]],
		autocomplete:        [],
		autocompletefilter:  [],
		streams:             [],
		offlineStreams:      [],
		load:                false,
		chartContainerDay:   false,
		modalWindow:         false,
		hiddenParameters:    false,
		showfilter:          true,
		playlists:           [],
		countPlaylists:      "",
		channelList:         [{
			archive_limit: "",
			display_name:  "",
			name:          "",
			poster_url:    "",
			is_censored:   "",
			is_federal:    "",
			epg_api_id:    "",
			epg_jtv:       "",
			is_free:       "",
			is_ottfree:    "",
			operator:      ""
		}],
		playlist:            [],
		countChannel:        0,
		genre:               [],
		selectedGenre:       "",
		editingPlaylist:     false,
		ch:                  "",
		thisChannel:         {},
		editingChannelList:  true,
		operator:            "",
		streamers:           [],
		ott:                 false,
		viewUser:            "",
		prevPath:            "",
		nameRequest:         "",
		usersApp:            [],
		thisUserApp:         {},
		tooLargePayload:     false,
		emptyPayload:        false,
		incorrectData: false
	},
	getters:   {
		getIncorrectData(state) {
			return state.incorrectData
		},
		getEmptyPayload(state) {
			return state.emptyPayload;
		},
		getTooLargePayload(state) {
			return state.tooLargePayload;
		},
		getParameters(state) {
			return state.parameters;
		},
		getSelectedMenu(state) {
			return state.selectedMenu;
		},
		getReqUserRole(state) {
			return state.reqUserRole;
		},
		getHiddenParameters(state) {
			return state.hiddenParameters;
		},
		getArray(state) {
			return state.arrayTotal[state.cycle];
		},
		getCycle(state) {
			return state.cycle;
		},
		getOptionForParameters(state) {
			return state.optionForParameters;
		},
		getShowFilter(state) {
			return state.showfilter;
		},
		getAutocomplete(state) {
			return state.autocomplete;
		},
		getAutocompleteFilter(state) {
			return state.autocompletefilter;
		},
		getStreams(state) {
			return state.streams;
		},
		getOfflineStreams(state) {
			return state.offlineStreams;
		},
		getLoad(state) {
			return state.load;
		},
		getChartContainerDay(state) {
			return state.chartContainerDay;
		},
		getModalWindow(state) {
			return state.modalWindow;
		},
		getPlaylists(state) {
			return state.playlists;
		},
		getCountPlaylists(state) {
			return state.countPlaylists;
		},
		getChannelList(state) {
			return state.channelList;
		},
		getPlaylist(state) {
			return state.playlist;
		},
		getCountChannel(state) {
			return state.countChannel;
		},
		getGenre(state) {
			return state.genre;
		},
		getSelectedGenre(state) {
			return state.selectedGenre;
		},
		getEditingPlaylist(state) {
			return state.editingPlaylist;
		},
		getUserRights(state) {
			return state.reqUserRole.toString() === "Администратор уровня Бог"
				|| state.reqUserRole.toString() === "Power User";
		},
		getCh(state) {
			return state.ch;
		},
		getThisChannel(state) {
			return state.thisChannel;
		},
		getEditingChannelList(state) {
			return state.editingChannelList;
		},
		getCurrentOperator(state) {
			return state.operator;
		},
		getStreamers(state) {
			return state.streamers;
		},
		getOtt(state) {
			return state.ott;
		},
		getViewUser(state) {
			return state.viewUser;
		},
		getPrevPath(state) {
			return state.prevPath;
		},
		getNameRequest(state) {
			return state.nameRequest;
		},
		getUsersApp(state) {
			return state.usersApp;
		},
		getThisUserApp(state) {
			return state.thisUserApp;
		}
	},
	actions:   {
		setParameter({ commit }, payload) {
			commit("setParameter", payload);
		},
		setSelectedMenu({ commit }, payload) {
			commit("setSelectedMenu", payload);
		},
		setReqUserRole({ commit }, payload) {
			commit("setReqUserRole", payload);
		},
		setHiddenParameters({ commit }, payload) {
			commit("setHiddenParameters", payload);
		},
		setArray({ commit, state }, data) {
			if (data.data.uid !== undefined && data.data.uid !== "") {
				data.data.uid = data.data.uid.trim();
			}
			performRequest(data.command, data.data, a => {
				if (a.code === 200) {
					setTimeout(() => {
						if (_.isArray(a.data) && a.data.length > 0) {
							commit("setArray", a.data);
							state.nameRequest = data.command.name;
						} else {
							commit("setEmptyPayload", true);
						}
						commit("setLoad", false);
					}, 500);

				} else if (a.code === 413) {
					commit("setTooLargePayload", true);
					commit("setLoad", false);
				} else if (a.code === 400) {
					commit('setIncorrectData', true);
					commit("setLoad", false);
				}
				else {
					commit("setLoad", false);
				}


			});
		},
		setCycle({ commit }, payload) {
			commit("setCycle", payload);
		},
		setOptionForParameters({ commit }, payload) {
			commit("setOptionForParameters", payload);
		},
		setFilter({ commit }, payload) {
			commit("setFilter", payload);
			commit("setLoad", false);
		},
		setPlaylists({ commit }, payload) {
			commit("setPlaylists", payload);
		},
		setChannelist({ commit }, payload) {
			commit("setChannelist", payload);
		},
		setPlaylist({ commit }, payload) {
			commit("setPlaylist", payload);
		},
		setGenre({ commit }) {
			performRequest(
				{
					section: "tvcontent.genre",
					name:    "getGenreList"
				},
				{
					operator: state.viewUser
				},
				a => {
					if (a.code === 200) {
						commit("setGenre", a.data);
					} else {
						console.log("ошибка при получении жанров");
					}

				}
			);
		}
	},
	mutations: {
		setIncorrectData(state, payload) {
			state.incorrectData = payload
		},
		setTooLargePayload(state, payload) {
			state.tooLargePayload = payload;
		},
		setEmptyPayload(state, payload) {
			state.emptyPayload = payload;
		},
		setThisUserApp(state, payload) {
			state.thisUserApp = payload;
		},
		setUsersApp(state, payload) {
			state.usersApp = payload;
		},
		setParameter(state, payload) {
			state.parameters = payload;
		},
		setSelectedMenu(state, payload) {
			state.selectedMenu = payload;
		},
		setReqUserRole(state, payload) {
			state.reqUserRole = payload;
		},
		setHiddenParameters(state, payload) {
			state.hiddenParameters = payload;
		},
		setArray(state, payload) {
			state.arrayTotal  = _.chunk(payload, 50);
			state.arrayFilter = payload;
		},
		setCycle(state, payload) {
			state.cycle = payload;
		},
		setOptionForParameters(state, payload) {
			state.optionForParameters = payload;
		},
		deleteArray(state) {
			state.arrayTotal  = [[]];
			state.arrayFilter = [[]];
		},
		setShowFilter(state, payload) {
			state.showfilter = payload;
		},
		setAutocomplete(state, payload) {
			state.autocomplete = payload;
		},
		setAutocompleteFilter(state, payload) {
			state.autocomplete.forEach(el => {
				if (el.indexOf(payload) !== -1) {
					state.autocompletefilter.push(el);
				}
			});
		},
		deleteAutocompleteFilter(state) {
			state.autocompletefilter = [];
		},
		setFilter(state, payload) {
			state.cycle = 0;
			let array   = [];
			state.arrayFilter.forEach(el => {
				for (let item in el) {
					if (el.hasOwnProperty(item)) {
						if (
							el[item]
								.toString()
								.trim()
								.toUpperCase()
								.indexOf(
									payload
										.trim()
										.toString()
										.toUpperCase()
								) !== -1
						) {
							return array.push(el);
						}
					}

				}
			});
			if (array.length > 0) {
				state.arrayTotal = _.chunk(array, 50);
			} else {
				state.hiddenParameters = true;
				state.modalWindow      = true;
			}
		},
		setStreams(state, payload) {
			state.streams = payload;
		},
		setOfflineStreams(state, payload) {
			state.offlineStreams = payload;
		},
		setLoad(state, payload) {
			state.load = payload;
		},
		setChartContainerDay(state, payload) {
			state.chartContainerDay = payload;
		},
		setModalWindow(state, payload) {
			state.modalWindow = payload;
		},
		setPlaylists(state, payload) {
			state.playlists = payload;
		},
		addNewPlaylist(state, payload) {
			state.playlists.push(payload);
		},
		setCountPlaylists(state, payload) {
			state.countPlaylists = payload;
		},
		setChannelist(state, payload) {
			state.channelList = payload;
		},
		setCountChannel(state, payload) {
			state.countChannel = payload;
		},
		setPlaylist(state, payload) {
			state.playlist = payload;
		},
		setGenre(state, payload) {
			state.genre = payload;
		},
		setSelectedGenre(state, payload) {
			state.selectedGenre = payload;
		},
		setEditingPlaylist(state, payload) {
			state.editingPlaylist = payload;
		},
		setCh(state, payload) {
			state.ch = payload;
		},
		setThisChannel(state, payload) {
			state.thisChannel = payload;
		},
		setEditingChannelList(state, payload) {
			state.editingChannelList = payload;
		},
		setOperator(state, payload) {
			state.operator = payload;
		},
		setStreamers(state, payload) {
			state.streamers = payload;
		},
		setOtt(state, payload) {
			if (state.operator === "root") {
				state.ott = true;
			} else {
				payload === 0 ? state.ott = true : state.ott = false;
			}
		},
		setViewUser(state, payload) {
			state.viewUser = payload;
		},
		setPrevPath(state, payload) {
			state.prevPath = payload;
		},
	}
});



// WEBPACK FOOTER //
// ./src/store/index.js